import { createSlice } from "@reduxjs/toolkit";
const slice = createSlice({
    initialState: [],
    name: "notificationReducers",
    reducers: {
        addNotification: (state, action) => {
            if (action.payload) {
                state.push(action.payload);
            }
        },
        updateNotification: (state, action) => {
            const index = state.findIndex((el) => el.id === action.payload.key);
            const { newMessage } = action.payload;
            if (state[index]) {
                state[index].message = newMessage;
            }
        }
    }
});
export const notificationsReducers = slice.reducer;
export const { addNotification, updateNotification } = slice.actions;
